import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { vinErrorText } from './vinExtractionErrors';

/**
 * A read that failed, with Retry: `message` says what failed; the description is the API's error (by its `code`)
 * when `status` is 'error', else `invalidDescription` for a body whose shape could not be rendered.
 */
export default function VinLoadError({ status, error, message, invalidDescription, onRetry }) {
    const { t } = useTranslation('vinExtraction');

    return (
        <Alert
            type="error"
            showIcon
            message={message}
            description={status === 'error' ? vinErrorText(t, error) : invalidDescription}
            action={
                <Button size="small" onClick={onRetry}>
                    {t('retry')}
                </Button>
            }
        />
    );
}
